import type { MaybeRefOrGetter } from 'vue';
import type { DateLike, UseDateFormatOptions } from '@vueuse/core';
import { useDateFormat } from '@vueuse/core';
import { unref } from 'vue';
import { DATE_FORMAT } from '~/app/constants/dateFormat';

export function useLocalisedDate(
  date: MaybeRefOrGetter<DateLike>,
  formatStr: MaybeRefOrGetter<string> = DATE_FORMAT.DEFAULT,
  options: UseDateFormatOptions = {}) {
  const { locale } = useI18n();

  return unref(useDateFormat(date, formatStr, { locales: unref(locale), ...options }));
}
